import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'categoryInput',
    'dateFilterInput',
    'mappingInput',
    'numberSignInput',
    'operationInput',
  ]

  connect() {
    this.handleInputDisabling()
  }

  handleInputDisabling() {
    if (this.mappingInputTarget.value === '') {
      this.categoryInputTarget.disabled = true
      this.dateFilterInputTarget.disabled = true
      this.numberSignInputTarget.disabled = true
      this.operationInputTarget.disabled = true
    } else {
      this.categoryInputTarget.disabled = false
      if (this.categoryInputTarget.value === 'ledger') {
        this.dateFilterInputTarget.disabled = false
      } else {
        this.dateFilterInputTarget.disabled = true
      }
      this.numberSignInputTarget.disabled = false
      this.operationInputTarget.disabled = false
    }
  }
}
